<template>
  <div v-if="isDefault">
    <v-row>
      <v-col cols="12" md="6" lg="4">
        <v-card class="elevation-12">
          <v-card-title>
            <v-btn color="primary" text :to="{name: 'mail-create-pdf-form'}">{{ $t('dashboardPage.cards.createFromPdf') }}</v-btn>
          </v-card-title>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="6" lg="4">
        <v-card class="elevation-12">
          <v-card-title>
            <v-btn color="primary" text :to="{name: 'mails-listing-draft'}">{{ $t('dashboardPage.cards.openCreated') }}</v-btn>
          </v-card-title>
        </v-card>
      </v-col>
      <v-col cols="12" md="6" lg="4">
        <v-card class="elevation-12">
          <v-card-title>
            <v-btn color="primary" text :to="{name: 'mails-listing-sent'}">{{ $t('dashboardPage.cards.openSent') }}
            </v-btn>
          </v-card-title>
        </v-card>
      </v-col>
      <v-col cols="12" md="6" lg="4">
        <v-card class="elevation-12">
          <v-card-title>
            <v-btn color="primary" text :to="{name: 'mails-listing-all'}">{{ $t('dashboardPage.cards.openAll') }}</v-btn>
          </v-card-title>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" md="6" lg="4" v-if="hasPermissionToSeeUnitStatistics">
        <v-card class="elevation-12">
          <v-card-title>
            <v-btn color="primary" text :to="{name: 'user-unit-statistics-page'}">{{ $t('dashboardPage.cards.myDepartments') }}</v-btn>
          </v-card-title>
        </v-card>
      </v-col>
      <v-col cols="12" md="6" lg="4">
        <v-card class="elevation-12">
          <v-card-title>
            <v-btn color="primary" text :to="{name: 'track', params: {uid: ' '}}">{{ $t('dashboardPage.cards.letterProtocol') }}</v-btn>
          </v-card-title>
        </v-card>
      </v-col>
    </v-row>
  </div>

</template>

<script>
import {LAYOUT_TITLE_CHANGED} from "@/store/modules/layout/actions";
import {Default} from '@/enums/user.type';

export default {
  name: "DashboardPage",
  computed: {
    isDefault() {
      return this.$store.getters.appIsInitialized && this.$store.getters.appLogin?.type === Default;
    },
    hasPermissionToSeeUnitStatistics() {
      return this.$store.getters.appLogin.unit.isHead;
    }
  },
  created() {
    this.$store.dispatch(LAYOUT_TITLE_CHANGED, this.$t('dashboardPage.pageTitle'))
  }
}
</script>

<style scoped>

</style>